import FullParagraphComponent from "segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component";
import classnames from "classnames";
import AssetComponent from "/components/core/asset/asset-component";
import TopLogosComponent from "segments/desktop/logos/layouts/top-logos/top-logos-component.js";
import { StyledVideoBackgroundAssetComponent } from "./video-background-asset-component.scss";
import DefaultProps from "./default-props";

const VideoBackgroundAssetComponent = (props) => {
  const {
    assetConfig,
    fullParagraphConfig,
    addDarkOverlay,
    hideBlackBars,
    alignToLogo,
    paragraphAdvancedProps,
    logosProps,
    topLogosAdvancedProps,
    segmentHeight,
    segmentMinHeight,
    segmentMaxHeight,
    videoPlayerWidth,
    videoPlayerHeight,
    videoPlayerPositionTop,
    videoPlayerPositionLeft,
    logosBottomMargin,
  } = props;

  const { useLogos, ...restOfLogosProps } = logosProps || {};
  const videoHeight = assetConfig?.video?.height;

  return (
    <StyledVideoBackgroundAssetComponent
      videoHeight={videoHeight}
      segmentHeight={segmentHeight}
      segmentMinHeight={segmentMinHeight}
      segmentMaxHeight={segmentMaxHeight}
      videoPlayerWidth={videoPlayerWidth}
      videoPlayerHeight={videoPlayerHeight}
      videoPlayerPositionTop={videoPlayerPositionTop}
      videoPlayerPositionLeft={videoPlayerPositionLeft}
      logosBottomMargin={logosBottomMargin}
    >
      <div className={classnames("video-wrapper", { "hide-black-bars": hideBlackBars })}>
        <AssetComponent {...assetConfig} hideControls={true} hideBlackBars={hideBlackBars} />
        {addDarkOverlay && <div className="dark-overlay" />}
      </div>
      <div className={classnames("content-wrapper", { "align-to-logo": !!alignToLogo })}>
        <FullParagraphComponent {...fullParagraphConfig} {...paragraphAdvancedProps} />
        {useLogos && <TopLogosComponent {...restOfLogosProps} {...topLogosAdvancedProps} />}
      </div>
    </StyledVideoBackgroundAssetComponent>
  );
};

VideoBackgroundAssetComponent.defaultProps = DefaultProps;

export default VideoBackgroundAssetComponent;
